import type { FunctionComponent } from 'react';
import React from 'react';
import { TEXT } from '../../lib/utils/text';
import { Text } from '../text';
export const ConsentButton: FunctionComponent = () => {
  const handleCookieSettingsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.Cookiebot?.renew();
  };
  return <a href='#' style={{
    cursor: 'pointer'
  }} onClick={handleCookieSettingsClick} data-sentry-component="ConsentButton" data-sentry-source-file="index.tsx">
            <Text tag='span' typeStyle='body-xs' color='dim' data-sentry-element="Text" data-sentry-source-file="index.tsx">
                {TEXT.doNotSellMyPersonalInformation}
            </Text>
        </a>;
};
export default ConsentButton;